/** Dates read identically in every Linked Records table and in this drawer. */
export const DATE_TIME_FORMAT = 'MMM DD, YYYY hh:mmA';

/**
 * The drawer's own tabs wrapper. The host screen's `.operation-details-tabs`
 * stays mounted behind the drawer, so the tables need a selector that can only
 * resolve to this one — `document.querySelector` returns the first match.
 */
export const DRAWER_TABS_WRAPPER_CLASS = 'linked-record-drawer-tabs';
export const DRAWER_TABS_WRAPPER_SELECTOR = `.${DRAWER_TABS_WRAPPER_CLASS}`;

export const DRAWER_CONTENT_CLASS = 'linked-record-drawer-content';

/** Panel is 702 wide at the design's 1280 viewport, and never narrower. */
export const DRAWER_WIDTH_RATIO = 0.548;
export const DRAWER_MIN_WIDTH_PX = 520;

/** Footer spans 752-832 in the design; the tab section ends at 720. */
export const DRAWER_FOOTER_HEIGHT_PX = 80;
export const DRAWER_TABLE_BOTTOM_GAP_PX = 32;
export const DRAWER_CONTENT_BOTTOM_RESERVE_PX =
  DRAWER_FOOTER_HEIGHT_PX + DRAWER_TABLE_BOTTOM_GAP_PX;

const DRAWER_TAB_STRIP_HEIGHT_PX = 40;
/** Tab strip, the pane's own 32px top padding, and its 2px of borders. */
export const DRAWER_DETAILS_CHROME_PX = DRAWER_TAB_STRIP_HEIGHT_PX + 32 + 2;

export const DRAWER_DETAILS_FALLBACK_MAX_HEIGHT = 'calc(100vh - 420px)';

/** Crop Zone 240 + Crop 179 + two 152s, measured off the design's table. */
export const DRAWER_APPLIED_AREA_COLUMN_WIDTHS = {
  cropZone: 240,
  crop: 179,
  farm: 152,
  appliedArea: 152
};

/**
 * Rows the drawer omits relative to the full detail view. The design's Details
 * tab is six rows: Start Time, End Time and Work Type (added by the drawer),
 * then Authorization, Record Created and Tags.
 */
export const DRAWER_HIDDEN_DETAIL_KEYS = [
  'timingEvent',
  'applicationMethod',
  'equipments',
  'recordSource',
  'cropSeasons',
  'reiExpirationDate',
  'phiExpirationDate',
  'id',
  'applicators'
];
